import { Service } from '@tino-frontend/adapters'
import { GeneratePixCodePayload, GeneratePixCodeResponse } from '@types'

export class PaymentService {
  constructor(private readonly merchantBFF: Service) {}

  generatePixCode({
    company_id,
    ...rest
  }: GeneratePixCodePayload): Promise<GeneratePixCodeResponse> {
    return this.merchantBFF.post(
      `/v1/company/${company_id}/generate-pix-code`,
      {
        company_id,
        ...rest,
      }
    )
  }
}
